$(document).ready(function(){


let query = `{
  products(first: 10, query: "product_type:Transmitters, tag:transmitter_control") {
    edges {
      node {
        id
        title 
        onlineStoreUrl
        priceRange {    
          maxVariantPrice {
            amount
          }
        }          
        metafields(first: 10, namespace: "accentuate") {
          edges {
            node {
              key
              value
            }
          }
        }
      }
    }
  }
}
`;

 let query2 = `query {
  productByHandle(handle: "yr1326-7-channel-white-transmitter") {
    metafields(first: 5, namespace: "accentuate") {
        edges {
        node {
          key
          value
        }
      }
    }
  }
}`;
  
  let settings = {
    'async': true,
    'crossDomain': true,
    'url': 'https://electric-blinds-curtains.myshopify.com/api/graphql',    
    'method': 'POST',
    'headers': {
        'X-Shopify-Storefront-Access-Token': 'd8180a1d10aa0d34ce1522ded28d4895',
        'Content-Type': 'application/json',
    },
    'data': JSON.stringify({query: query})
};



$.ajax(settings).done(function (response) {

    jQuery.each( response.data.products.edges, function( i, val ) {
      const popupSection = '#transmitters-popup-content';
      let itemTitle = val.node.title;
      let itemPrice = val.node.priceRange.maxVariantPrice.amount;
      let itemDescription = undefined;
      let itemImage = undefined;
      jQuery.each( val.node.metafields.edges, function( i, val ) {
        if(val.node.key == "transmitter_popup_description"){
            itemDescription = val.node.value;
        }else if(val.node.key == "transmitter_popup_image"){
            itemImage = val.node.value
        }
      });
     
      const itemURL = val.node.onlineStoreUrl;
      itemPrice = parseFloat(itemPrice).toFixed(2)
      $(popupSection).append(buildTransmitterHtml(itemTitle, itemDescription, itemImage, itemPrice, itemURL));

      
    });

    
});

function buildTransmitterHtml(title, description, image, itemPrice, itemURL){
  return `<div class="actual-transmitter-content" style="">
          <div style="height:350px;width:100%;"> 
            <div style="text-align:center">
            <img style="width:127px;height:236px" src='${image}'/>
            </div>
            </br>
            <h3 style="font-size:16px;font-family: Montserrat,SemiBold;">${title}</h3>
            <p style="font-size:12px;">${description}</p>
            <p style="font-size:12px;display:inline-block;float:left;font-weight: bold">&#163;${itemPrice}</p>
            <p style="font-size:12px;display:inline-block;float:right;text-decoration:underline;"> <a style="color:#E37222" target="_blank" href="${itemURL}">View Product</a></p>
          </div>
          </div>
          `;

}

let isPopupVisible = false;
$( "#viewTransmittersLink" ).click(function() {  
  if(isPopupVisible == true){
    isPopupVisible = false;
    $('#transmitters-popup-section').hide();
    $('body').css('overflow-y','visible');    
    
  }else{
    isPopupVisible = true;
    $('#transmitters-popup-section').show();
    $("body").css("overflow-y", "hidden");

  }
  
});

$( "#transmitters-popup-close-icon" ).click(function() {
    $('#transmitters-popup-section').hide();
    $('body').css('overflow-y','scroll');   
    isPopupVisible = false;
});
  
$( "#transmitters-popup-close-icon-mobile" ).click(function() {
    $('#transmitters-popup-section').hide();
    $('body').css('overflow-y','scroll');   
    isPopupVisible = false;
});







});